import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaPlayerComponent } from './media-player/media-player.component';
import { MediaPlaylistComponent } from './media-playlist/media-playlist.component';
import { VideoGalleryComponent } from './video-gallery/video-gallery.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
//import { CustomCarouselComponent } from '../feed/custom-carousel/custom-carousel.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [MediaPlayerComponent, MediaPlaylistComponent, VideoGalleryComponent],
  exports: [MediaPlayerComponent, MediaPlaylistComponent, VideoGalleryComponent],
  imports: [CommonModule, PipesModule, FGBSharedModule],
})
export class MediaPlayerModule {}
